import React, { FC, ReactElement, useContext } from 'react'
import CLanguageHandler from '../../../../NonReact/Languages/LanguageHandler'
import { LanguageContext } from '../../../../React/Common/Contexts'

type Props = {
    title: string
}

export const PageTitle: FC<Props> = ({ title }: Props): ReactElement => {
    const language: CLanguageHandler = useContext(LanguageContext) as CLanguageHandler
    return (
        <div className='router-page-title'>
            <h1>{language.get(title)}</h1>
        </div>
    )
}
